import { IoMdAdd } from 'react-icons/io'
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogOverlay,
  DialogTitle,
  DialogTrigger,
} from 'ui/dialog'
import { Button } from 'ui/button'
import { useToast } from 'ui/use-toast'
import { useCallback, useMemo } from 'react'
import type { ErrorToastHandler } from '../hooks/useError'
import { useMessageTemplateCreate } from '../hooks/useMessageTemplateCreate'
import { IMessageTemplate } from '../providers/MessageTemplate.provider'
import { MessageTemplateEditorV2 } from './MessageTemplateEditorV2'
import { TranslatorOnlyString } from './Translator'
import { useTranslation } from 'i11n/client'

export const CreateMessageTemplateV2 = (props: {
  channel: IMessageTemplate['channel']
  btnLabel?: string
}) => {
  const t = useTranslation()
  const { toast } = useToast()
  const onErrorToast = useCallback<ErrorToastHandler>(
    (opts) => {
      toast({
        title: opts.title,
        description: opts.description,
        variant: 'destructive',
      })
    },
    [toast],
  )
  const messageTemplateCreateProps = useMemo(
    () => ({
      btnLabel: props.btnLabel,
      onErrorToast,
    }),
    [onErrorToast, props.btnLabel],
  )
  const {
    btnLabel,
    createMessageTemplate,
    formId,
    isLoading,
    onCreateMessageTemplate,
    setIsLoading,
    setCreateMessageTemplate,
  } = useMessageTemplateCreate(messageTemplateCreateProps)

  return (
    <>
      <Button
        className='mt-3'
        onClick={() => setCreateMessageTemplate(props.channel)}
        size='sm'
      >
        <IoMdAdd className='mr-2' />
        {btnLabel}
      </Button>

      <Dialog
        onOpenChange={(open) => {
          if (!open) {
            setCreateMessageTemplate(undefined)
          }
        }}
        open={!!createMessageTemplate}
      >
        <DialogContent
          overlayClassName='flex items-center justify-center'
          className='max-w-6xl w-full'
        >
          <DialogHeader>
            <DialogTitle>
              {t('Crear plantilla para')}{' '}
              {TranslatorOnlyString({ children: createMessageTemplate })}
            </DialogTitle>
          </DialogHeader>
          <MessageTemplateEditorV2
            onSubmit={(data) =>
              onCreateMessageTemplate(data, () => {
                toast({
                  description: t('Plantilla de mensaje creada'),
                  variant: 'success',
                })
              })
            }
            formId={formId}
            channel={createMessageTemplate}
          />
          <DialogFooter>
            <Button
              type='submit'
              disabled={isLoading}
              loading={isLoading}
              form={formId}
              className='mr-3'
            >
              {t('Crear')}
            </Button>
            <Button
              disabled={isLoading}
              onClick={() => setCreateMessageTemplate(undefined)}
              variant='ghost'
            >
              {t('Cancelar')}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  )
}
